import React, { useState } from "react";
import { enhancePrompt, generateImage } from "../utils/apiHelpers";

const WorkflowText = () => {
  const [input, setInput] = useState("");
  const [enhanced, setEnhanced] = useState("");
  const [images, setImages] = useState([]);

  // Enhance Prompt
  const handleEnhance = async () => {
    const result = await enhancePrompt(input);
    setEnhanced(result);
  };

  // Generate Images
  const handleGenerate = async () => {
    const result = await generateImage(enhanced || input);
    setImages(result);
  };

  return (
    <div style={{ marginBottom: "30px" }}>
      <h2>Creative Studio</h2>

      {/* Input */}
      <textarea
        placeholder="Enter your prompt"
        value={input}
        onChange={(e) => setInput(e.target.value)}
        style={{ width: "100%", height: "60px" }}
      />

      <br />
      <button onClick={handleEnhance}>Enhance</button>

      {/* Enhanced Output */}
      {enhanced && (
        <>
          <h3>Approve Prompt</h3>
          <textarea
            value={enhanced}
            onChange={(e) => setEnhanced(e.target.value)}
            style={{ width: "100%", height: "60px" }}
          />

          <br />
          <button onClick={handleGenerate}>Generate</button>
        </>
      )}

      {/* Images */}
      <div style={{ marginTop: "20px" }}>
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt="generated"
            width="200"
            style={{ marginRight: "10px" }}
          />
        ))}
      </div>
    </div>
  );
};

export default WorkflowText;